/*
null
undefined
NaN
empty
string ("")
0
false
 */
var fastNull = function (value) { return typeof value != 'undefined' && value; };
var considerNull = ['null', 'false', 'undefined'];
var replaceNullNumericValues = function (object, keys) {
    var replaceAll = !Array.isArray(keys) || (keys.length === 0);
    var out = {};
    for (var _i = 0, _a = Object.entries(object); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        out[key] = value;
        if (replaceAll || keys.includes(key)) {
            if (!fastNull(value) || considerNull.includes(value.toString())) {
                out[key] = 0;
            }
        }
    }
    return out;
};
export { replaceNullNumericValues };
